<template>
  <div class="row">
    <div class="col-md-6 col-md-offset-3">
      <label> {{ computeCaption(fieldsEn.search_label, $store.state.lang.value.toLowerCase()) }}</label>
      <el-input :placeholder="filter" v-model="searchedWord"></el-input>
      <el-radio-group
        size="small"
        value-key="test"
        :name="'filter'"
        v-model="filter"
        class="flex-end"
      >
        <el-radio-button
          v-for="(filter, index) in filterArray"
          tabindex="0"
          :key="index"
          :label="filter"
        >
          {{ computeCaption(filter, $store.state.lang.value.toLowerCase()) }}
        </el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import {Input, Button, RadioGroup, Radio, RadioButton} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
export default {
  name: 'SearchBar',
  props: ['label', 'filters'],
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton
  },
  mixins: [
    TranslationsUtils
  ],
  data () {
    return {
      searchedWord: '',
      filter: '',
      filterArray: [],
      fieldsEn: {
        'search_label': 'Search'
      }
    }
  },
  methods: {
    handleSearch (word) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.$emit('setLoading', true)
      this.timer = setTimeout(() => {
        this.$emit('handleSearchValue', {word: word, searchType: this.filter})
        this.$emit('setLoading', false)
      }, 500)
    }
  },
  beforeMount () {
    if (this.filters) {
      this.filterArray = this.filters
    }
    this.filter = this.filterArray[0]
  },
  mounted () {
    if (this.label) {
      this.fieldsEn.search_label = this.label
    }
  },
  computed: {
  },
  watch: {
    'searchedWord': {
      handler (value) {
        this.handleSearch(value)
      }
    },
    'filter': {
      handler (value) {
        this.searchedWord = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
.flex-end {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/ResultsAccountParts/SearchBar.vue